/**
 * @file step
 * @author zhaomiaoyuan
 */
import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import UploadProof from '../../components/UploadProof/index.tsx';
import InputFormItem from '../../components/InputFormItem/index.tsx';
import SendCode from '../../components/SendCode/index.tsx';
// import AgreeProtocol from '../../components/AgreeProtocol/index.tsx';
import DefaultGov from '../../components/DefaultGov/index.tsx';
import {
    socialTip,
    certTip
} from '../../components/UploadProof/uploadTip.tsx';
import {recordProxy, bCat_2055_request} from '../../util';
import zizhi from '../../asset/img/attest/zizhi.jpg';
import yunying from '../../asset/img/attest/yunying.png';
import videoDemo from '../../asset/img/appeal/video-demo.gif';

import {initialStateErr} from './conf';

// import {Button, message} from 'antd';
import './appeal.less';
const GovernmentModal = (props) => {
    const {
        updateAppeal,
        appealData,
        fetchSendCode,
    } = props;

    function onSendCodeChange ({captchaTip}) {
        const recordType = window.location.pathname.indexOf('/occupy') > -1
            ? 'report-number_captcha' : 'report-mark_captcha';
        recordProxy(
            recordType,
            'click',
            captchaTip === '获取验证码' ? '获取验证码' : '重新发送'
        );
    }

    const setDefaultGov = (value) => {
        updateAppeal({
            isShowDefaultGov: value
        });
    };
    if (appealData.isShowDefaultGov) {
        const onDefaultGovClick = () => {
            recordProxy('url-replay', 'click', '继续申诉');
            setDefaultGov(false);
        };
        return <DefaultGov name={appealData.appealType === 2 ? '占用' : ''} nextClick={onDefaultGovClick}/>;
    }
    return (
        <div className="person-modal">
            <UploadProof
                title="社会信用代码证"
                isMsgRequired={true}
                type="social"
                maxImgLength={1}
                data={appealData}
                updateData={updateAppeal}
                tips={socialTip()}
                demoImgs={[zizhi]}
            />
            <InputFormItem
                title="政府名称"
                isMsgRequired={true}
                placeholder="请输入政府名称"
                type="nameGov"
                data={appealData}
                updateData={updateAppeal}
                style={{width: '424px'}}
                demoImgs={[]}
            />
            <UploadProof
                proofType="video"
                title="证明材料"
                isMsgRequired={true}
                type="cert"
                maxImgLength={10}
                data={appealData}
                updateData={updateAppeal}
                tips={certTip()}
                demoImgs={[yunying, videoDemo]}
            />
            <InputFormItem
                title="联系邮箱"
                isMsgRequired={true}
                placeholder="请输入正确的邮箱地址用来接收审核结果"
                type="email"
                data={appealData}
                updateData={updateAppeal}
                style={{width: '424px'}}
                demoImgs={[]}
            />
            <SendCode
                title="邮箱验证码"
                isMsgRequired={true}
                type="emailCode"
                data={appealData}
                updateData={updateAppeal}
                sendData={appealData.email}
                fetchSendCode={fetchSendCode}
                onSendCodeChange={onSendCodeChange}/>

            {/* <AgreeProtocol
                type="isRead"
                data={appealData}
                updateData={updateAppeal} />
            <div className="btn-content">
                {!appealData.hasSearchUrl
                && <Button
                    className="btn-step2"
                    onClick={preClick}>上一步</Button>
                }
                <Button
                    className="btn-step2-primary"
                    type="primary"
                    disabled={!appealData.isRead}
                    onClick={nextClick}>提交</Button>
            </div> */}
        </div>
    );
};

GovernmentModal.propTypes = {
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object,
    fetchSendCode: PropTypes.func,
};

export default withRouter(GovernmentModal);

